import { useState } from "react";
import { DialogAppSDK } from "@contentful/app-sdk";
import { Button, Checkbox, Stack } from "@contentful/f36-components";
import { useSDK } from "@contentful/react-apps-toolkit";
import { NewFeaturesContent } from "../components";
import { NewFeaturesDialogData, NewFeaturesDialogParameters } from "../lib";

export const NewFeaturesDialog = () => {
    const sdk = useSDK<DialogAppSDK>();
    const { version } = (sdk.parameters.invocation?.valueOf() ?? {}) as NewFeaturesDialogParameters;
    const [stopShowing, setStopShowing] = useState(false);

    return (
        <Stack
            style={{ height: "100vh" }}
            flexDirection="column"
            alignItems="start"
            justifyContent="space-between"
            padding="spacingL">
            <Stack
                flexShrink={1}
                style={{ overflowY: "auto" }}
                flexDirection="column"
                alignItems="start"
                spacing="none">
                {version && <NewFeaturesContent version={version} />}
            </Stack>
            <Stack fullWidth justifyContent="space-between">
                <Checkbox isChecked={stopShowing} onChange={() => setStopShowing(!stopShowing)}>
                    Don't show this announcement again
                </Checkbox>
                <Button
                    variant="primary"
                    onClick={() => {
                        sdk.close({ stopShowing } satisfies NewFeaturesDialogData);
                    }}>
                    Close
                </Button>
            </Stack>
        </Stack>
    );
};
